import React from 'react';
import { useDispatch } from 'react-redux';
import MaterialIconToolTip from '../../../../common/MaterialIconToolTip';
import OverflowTip from '../../../../common/OverflowTip';
import { grantOrRevokeAdminAccess } from '../../../../actions/conversations';
import { openTextModalAction, closeModalAction } from '../../../../actions/modal';
import UserProfileImage from '../../components/UserProfileImage';
import UserPopup from '../../../../common/Popups/User';
import { removeMembersInChat } from '../../../../actions/chat';
import { useSelector } from 'react-redux';

const formName = 'leaveConversation';

function Member({ item: member, conversationId, admin }) {

    const isAdmin = member.role === 'ADMIN'
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData);

    const dispatch = useDispatch();

    const isMember = newLoggedUserData.user.id === member.id && member.role === 'MEMBER'

    // const isShowRemoveUserIcon = member.id !== newLoggedUserData.user.id;
    const removeMember = () => {
        dispatch(removeMembersInChat({ id: conversationId, users: [member.id] }));
    };

    const handleRemoveMember = () => {
        let heading = 'Remove Member';
        let text = `Do you want to remove member?`;
        let buttons = [
            {
                showLoading: true,
                textOrComponent: 'Yes',
                type: 'red',
                buttonClass: 'hover:bg-scogoLightFillRed',
                onClick: removeMember,
            },
            {
                textOrComponent: 'No',
                type: 'blue',
                buttonClass: 'hover:bg-scogobgsky',
                onClick: () => dispatch(closeModalAction()),
            },
        ];

        let closeOnBackdropClick = false;
        dispatch(openTextModalAction({ heading, text, buttons, closeOnBackdropClick, formName }));
    };


    return (
        <div className='flex onHoverShowCross' key={member._id}>
            <div>
                <div className='flex items-center mb-5'>
                    <div className='flex items-center'>
                        <div>
                            <UserProfileImage className='inline-block object-cover w-10 h-10 rounded-full text-center leading-9' imgUrl={member.profilePic} />
                        </div>
                        <div className='ml-m-9 '>
                            <div className='flex items-center gap-2'>
                                <UserPopup
                                    userId={member?.id}
                                    anchorOrigin={{
                                        vertical: 'center',
                                        horizontal: 'left',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                >
                                    <p className='text-scogo15 text-font10 font-normal max-w-xs'>
                                        <OverflowTip someLongText={member.display_name} />
                                    </p>
                                </UserPopup>
                                {member.isAdmin && <p className={`border-scogoorange border rounded-md text-scogoorange max-w-max text-xs flex items-center px-1.5 py-0.5`}>Admin</p>}
                            </div>
                            <p className='text-scogogray text-font9 font-normal'>{member.role}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='ml-auto hidden showCross'>
                <div className='flex items-center'>
                    {/* {isShowMakeAdminIcon && <MaterialIconToolTip
                        title={member.isAdmin ? 'Revoke Admin Rights' : 'Make Admin'}
                        childComponent={
                            <img
                                className='cursor-pointer w-4 h-4'
                                onClick={() => handleAdminRights({ userId: member.userId, isAdmin: member.isAdmin, username: member.username, groupName })}
                                alt='Admin'
                                src={process.env.PUBLIC_URL + `${member.isAdmin ? '/img/revoke_crown.svg' : '/img/crown.svg'}`}
                            />
                        }
                    />} */}
                    {(admin && !isAdmin) && <MaterialIconToolTip
                        onClick={() => handleRemoveMember()}
                        title='Remove User'
                        materialIconName='close'
                        materialIconClass='hover:text-scogoorange cursor-pointer material-icons text-scogoclosed text-font16'
                    />}
                </div>
            </div>
        </div>
    );
}

export default Member;
